const FantasyCasinoModule = () => import(/* webpackChunkName: "virtual-sport-module" */ './views/Module.vue');
const FantasyCasino = () => import(/* webpackChunkName: "fantasy-casino" */ './views/FantasyCasino.vue');

const FantasyCasinoRoutes = {
    path: '/',
    component: FantasyCasinoModule,
    children: [
        {
            path: 'fantasy',
            name: 'fantasy',
            component: FantasyCasino
        }
    ],
}

export default FantasyCasinoRoutes;